import React, { useEffect, useState } from "react";
import { PrintContainer } from "../../styles/Print";
import { useOrderRequests } from "../../helpers/OrderRequests";
export default function PrintInvoices() {
  const [invoices, setInvoices] = useState(null);
  const [total, setTotal] = useState(0);
  const { getInvoices } = useOrderRequests();
  useEffect(() => {
    if (invoices==null) {
      getInvoices().then(async (response) => {
        setInvoices(response.data.data);
        let totals = 0;
        let unit = "";
        const seter = await response.data.data.map((x) => {
          unit = x.currencyUnit;
          totals += x.totalCurrencyPrice;
        });
        setTotal(unit + totals);

        setTimeout(() => {
          window.print();
        }, 300);
      });
    }
  }, [invoices]);

  return (
    <PrintContainer>
      <h1>Fatura Listesi</h1>
      <ul>
        <li>
          
          <div>Kod</div>
          <div>Ad</div>
          <div>Tarih</div>
          <div>Durum</div>
          <div>
          Tutar
          </div>
        </li>
        {(invoices != null ? invoices : []).map((x) => {
          return (
            <li>
              <div>{x.invoiceCode}</div>
              <div>{x.detail}</div>
              <div>{x.date}</div>
              <div>{x.status}</div>
              <div>
                {x.currencyUnit}
                {x.totalCurrencyPrice}
              </div>
            </li>
          );
        })}
      </ul>
    </PrintContainer>
  );
}
